"use client";

import { HUB_BANNER_TONES, type HubBanner } from "./hubData";
import HeroCrossfade from "@/components/dashboard/jtbd/HeroCrossfade";

const BANNER_IMAGE_CLASS =
  "inset-0 h-full w-full object-cover object-[center_22%] sm:inset-y-0 sm:left-auto sm:right-0 sm:h-full sm:w-[35%]";

function bannerFade({ r, g, b }: { r: number; g: number; b: number }) {
  return `linear-gradient(to right, rgb(${r}, ${g}, ${b}) 0%, rgb(${r}, ${g}, ${b}) 65%, rgba(${r}, ${g}, ${b}, 0.72) 75%, rgba(${r}, ${g}, ${b}, 0.28) 78%, transparent 85%)`;
}

export default function CatalogSectionBanner({
  banner,
  priority = false,
}: {
  banner: HubBanner;
  priority?: boolean;
}) {
  const frames = banner.images.filter(Boolean);
  const poster = frames[0];
  const cycling = frames.length > 1;
  const tone = HUB_BANNER_TONES[banner.tone];

  return (
    <div
      className="relative h-[150px] overflow-hidden rounded-2xl sm:h-[300px] sm:rounded-3xl"
      style={{ backgroundColor: tone.fill }}
    >
      {cycling ? (
        <HeroCrossfade
          images={frames}
          alt=""
          imageClassName={BANNER_IMAGE_CLASS}
          priority={priority}
        />
      ) : poster ? (
        <img
          src={poster}
          alt=""
          className={`absolute ${BANNER_IMAGE_CLASS}`}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          draggable={false}
        />
      ) : null}

      <div
        className="absolute inset-0 sm:hidden"
        style={{ backgroundColor: `rgba(${tone.r}, ${tone.g}, ${tone.b}, 0.62)` }}
      />
      <div
        className="absolute inset-0 hidden sm:block"
        style={{ background: bannerFade(tone) }}
      />

      <div className="relative z-10 flex h-full max-w-xl flex-col justify-center px-4 sm:px-8 lg:px-10">
        {/*}
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/75 sm:text-xs">
          {banner.label}
        </p>
        */}
        <h2
          className="text-[1.5rem] font-bold leading-[1.12] text-white sm:mt-2 sm:text-[2rem] lg:text-[2.5rem]"
          style={{ fontFamily: "var(--font-merriweather)" }}
        >
          {banner.headline}
        </h2>
        {banner.subhead ? (
          <p className="mt-1 max-w-md text-xs leading-snug text-white/80 sm:mt-2 sm:text-sm sm:leading-relaxed sm:text-[15px]">
            {banner.subhead}
          </p>
        ) : null}
      </div>
    </div>
  );
}
